import React from 'react';
import { useRouter } from 'next/router';

type TTabOption = {
  label: string;
  key: string;
};
interface SectionTabProps {
  options: TTabOption[];
  selectedOption: string;
  setSelectedOption: React.Dispatch<React.SetStateAction<string>>;
}

function SectionTab({
  options,
  selectedOption,
  setSelectedOption,
}: SectionTabProps) {
  const router = useRouter();

  const pushQueryParam = (tab) => {
    router.push(
      {
        pathname: router.pathname,
        query: {
          _id: router.query._id,
          ...{ companyId: router.query.companyId },
          tab,
        },
      },
      undefined,
      { shallow: true }
    );
  };

  React.useEffect(() => {
    if (!router?.query?.tab) {
      pushQueryParam(options[0].key);
    } else {
      setSelectedOption(router.query.tab as string);
    }
  }, [router?.query?.tab]);

  return (
    <div className="flex flex-col w-full border-b md:border-b-neutral-300 mb-6">
      <div className="flex w-full flex-col sm:flex-row justify-center md:justify-start space-y-3 sm:space-y-0">
        {options.map((button) => (
          <button
            key={button?.key}
            type="button"
            className={`w-full  md:w-fit border-b -mb-[1px] hover:text-purple-900 hover:border-b-purple-900 flex items-center font-semibold flex-col px-3 py-1 text-sm    ${
              selectedOption === button?.key
                ? 'border-b-purple-300 text-purple-300 '
                : 'text-neutral-400 border-b-neutral-400 md:border-b-0'
            }`}
            onClick={(e) => {
              e.preventDefault();
              pushQueryParam(button?.key);
              setSelectedOption(button?.key);
            }}
          >
            {button?.label}
          </button>
        ))}
      </div>
    </div>
  );
}

export default SectionTab;
